export const hasNullByte = (value: string) => value.indexOf("\u0000") !== -1;

export const stripNullBytes = (value: string) => value.replaceAll("\u0000", "");
